<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h1 class="h4">Execution Plans</h1>
      <p>Execution Plans from all service teams</p>
    </div>
    <div class="action-container">
      <div class="form-check form-check-inline ms-4 toggle">
        <input
          type="checkbox"
          class="form-check-input"
          id="showLatestOnlySwitch"
          [(ngModel)]="showLatestOnly"
          (change)="onShowLatestOnlyChanged()" />
        <label class="form-check-label" for="showLatestOnlySwitch">Latest Execution Plans</label>
      </div>
      <button *ngIf="isAdminOrOperator" type="submit" class="btn btn-delete me-1" [disabled]="!hasRowSelected" (click)="batchRemovePlans()">
        Remove
      </button>
      <button type="submit" class="btn btn-primary me-1" (click)="refreshData()">Refresh</button>
      <a
        href="javascript:void(0)"
        class="topbar-item"
        (click)="exportExcel()"
        placement="top-right"
        container="body"
        ngbTooltip="Export to Excel"
        aria-label="Export to Excel">
        <span class="far fa-file-excel fa-lg"></span>
      </a>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [masterDetail]="true"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [excelStyles]="headerStyle"
      (selectionChanged)="onSelectionChanged($event)"
      [pagination]="true"
      tabindex="0"
      aria-label="All Regional Execution Plans List"
      (gridReady)="onGridReady($event)"
      (filterChanged)="onFilterChanged($event)">
    </ag-grid-angular>
  </div>
</div>
